import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/pages/home'
import Register from '@/pages/register'
import Protocal from '@/pages/protocal'
import Welcome from '@/pages/welcome'
import SharedHome from '@/pages/sharedHome'
import SharedGetCoupon from '@/pages/sharedGetCoupon'
import SharedWelcome from '@/pages/sharedWelcome'
import ThePublic from '@/pages/thePublic'
import ServiceIntroduce from "@/pages/serviceIntroduce"
import Hpds from "@/pages/hpds"
Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/protocal',
      name: 'protocal',
      component: Protocal
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/sharedHome',
      name: 'sharedHome',
      component: SharedHome
    },
    {
      path: '/sharedGetCoupon',
      name: 'sharedGetCoupon',
      component: SharedGetCoupon
    },
    {
      path: '/sharedWelcome',
      name: 'sharedWelcome',
      component: SharedWelcome
    },
    {
      path: '/thePublic',
      name: 'thePublic',
      component: ThePublic
    },
    {
      path: '/serviceIntroduce',
      name: 'serviceIntroduce',
      component: ServiceIntroduce
    },
    {
      path: '/hpds',
      name: 'hpds',
      component: Hpds
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js